import React from 'react';
import Layout from '../../components/Shared/Layout';
import Sesame from '../../components/Portfolio/sesame';
import '../../assets/css/sesame.css';
import * as ReactGA from 'react-ga';

const $ = typeof window !== `undefined` ? require('jquery') : null;

class SesamePage extends React.Component {
  /* constructor(props) {
      super(props);
  } */
  componentDidMount() {
    ReactGA.set({
      title: 'Portfolio/sesame',
    });
    ReactGA.pageview(this.props.location.pathname);
  }

  render() {
    return (
      <Layout>
        <Sesame />
      </Layout>
    );
  }
}

export default SesamePage;
